import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchSurgicalSafetyNextIp = async () => {
  const response = await axios.get(`${API_BASE_URL}/surgical_next_ip`);
  return response.data;
};

export const fetchPatientData = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);
  return response.data;
};

export const fetchSurgicalSafetyData = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_surgical_safety/${uhidNo}`);
  return response.data;
};

export const saveSurgicalSafety = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/surgical_safety`, data);
  return response.data;
};

export const updateSurgicalSafety = async (uhidNo, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_surgical_safety/${uhidNo}`, data);
  return response.data;
};

export const generateSurgicalShareToken = async (uhidNo) => {
    const response = await axios.post(`${API_BASE_URL}/generate_for_surgical_api_share_token/${uhidNo}`);
    return response.data;
};
